<div class="level-container">
    <span class="level-back" [style.borderBottomWidth]="height + 'px'" [style.borderLeftWidth]="width + 'px'"></span>
    <span class="level-current" [style.borderBottomWidth]="currentLevelToPxH() + 'px'" [style.borderLeftWidth]="currentLevelToPxW() + 'px'"></span>
</div>